export default __webpack_public_path__ + "static/den-logo-e3753c6566f807fde7d1e44db08079f4.svg";